import { render, staticRenderFns } from "./Reduce.vue?vue&type=template&id=26af2465&"
import script from "./Reduce.vue?vue&type=script&lang=js&"
export * from "./Reduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports